import './styles.scss'
import { FAQJsonLd } from 'gatsby-plugin-next-seo'
import { removeHtmlFromString } from 'src/utils/removeHtmlFromString'

import QuestionAnswer from './QuestionAnswer'

type FaqClubProps = {
  title: string
  items: Array<{
    active: boolean
    question: string
    response: string
  }>
}

interface DoubtsModalClubProps {
  doubtsArr?: FaqClubProps
  renderFaqSchema?: boolean
}

const FaqClub = ({
  doubtsArr,
  renderFaqSchema = true,
}: DoubtsModalClubProps) => {
  const faqJson =
    doubtsArr?.items
      .filter((item) => item.active)
      .map((item) => ({
        question: item.question,
        answer: removeHtmlFromString(item.response),
      })) ?? []

  return (
    <div id="duvidas" className="questions-container">
      {renderFaqSchema && <FAQJsonLd questions={faqJson} />}
      <div className={`content__questions ${doubtsArr?.title}`}>
        {doubtsArr?.items.map((item, index) => {
          return (
            <QuestionAnswer
              key={index}
              question={item.question}
              response={item.response}
              active={item.active}
            />
          )
        })}
      </div>
    </div>
  )
}

export default FaqClub
